import {
    type FlightApproximatePriceResponseBase,
    type AutomaticReserveDemandResponse,
    ClassOfServiceTypes,
} from '@clients/PricetrackApi';
import type TripPackage from '@itinerary/trip/TripPackage';
import { CabinClassRequest } from '@clients/FlightApi';

export interface AutomaticReserveDemandResponseExtended
    extends AutomaticReserveDemandResponse {
    packages: TripPackage[];
}

export type FlightAutoPrices = FlightApproximatePriceResponseBase & {
    isCustomPrice?: boolean;
};

// [ClassOfServiceTypes.NUMBER_5]: 'اکونومی پلاس' not included in cabin classes
export const classOfServiceEnumMap = [
    {
        value: ClassOfServiceTypes.NUMBER_0,
        title: 'همه',
        cabinClass: CabinClassRequest.All,
    },
    {
        value: ClassOfServiceTypes.NUMBER_1,
        title: 'اکونومی',
        cabinClass: CabinClassRequest.Economy,
    },
    {
        value: ClassOfServiceTypes.NUMBER_2,
        title: 'بیزینس',
        cabinClass: CabinClassRequest.Business,
    },
    {
        value: ClassOfServiceTypes.NUMBER_5,
        title: 'اکونومی پلاس',
        cabinClass: CabinClassRequest.EconomyPlus,
    },
];
